/**
 * Judge.me — auto-open Write Review modal when invoice QR is scanned.
 *
 * Drop this snippet into the FFlirtyGo Shopify theme right before </body>
 * (or in theme.liquid). When a customer scans the QR on their invoice they
 * land on /products/<handle>?wr=1#judgeme_product_reviews — this script
 * listens for ?wr=1 and clicks the "Write a review" button automatically,
 * so the customer sees the review form immediately, not a product page.
 *
 * Falls back gracefully: if Judge.me isn't loaded yet, the click is queued.
 *
 * Sheldon — install via:
 *   1. Open theme editor
 *   2. Edit code → layout/theme.liquid
 *   3. Paste this <script> block right before </body>
 *   4. Save → publish.
 */
(function () {
  if (!/[?&]wr=1\b/.test(location.search)) return;

  var triggered = false;
  function tryOpen() {
    if (triggered) return;
    var btn = document.querySelector(".jdgm-write-rev-link");
    if (btn) {
      triggered = true;
      // Scroll into view first (helps mobile UX) then click.
      btn.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(function () { btn.click(); }, 400);
    }
  }

  // Try immediately, then poll briefly while Judge.me boots up.
  document.addEventListener("DOMContentLoaded", tryOpen);
  var attempts = 0;
  var iv = setInterval(function () {
    attempts++;
    tryOpen();
    if (triggered || attempts > 25) clearInterval(iv);
  }, 400);
})();
